/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Manual_Qc_Related_Group_Not_FoundInputs */

const en_manual_qc_related_group_not_found = /** @type {(inputs: Manual_Qc_Related_Group_Not_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Could not find the related event group`)
};

const fr_manual_qc_related_group_not_found = /** @type {(inputs: Manual_Qc_Related_Group_Not_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Impossible de trouver le groupe d'evenements associe`)
};

const de_manual_qc_related_group_not_found = /** @type {(inputs: Manual_Qc_Related_Group_Not_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Die zugehörige Ereignisgruppe konnte nicht gefunden werden.`)
};

const it_manual_qc_related_group_not_found = /** @type {(inputs: Manual_Qc_Related_Group_Not_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Impossibile trovare il gruppo di eventi correlato`)
};

const ru_manual_qc_related_group_not_found = /** @type {(inputs: Manual_Qc_Related_Group_Not_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Не удалось найти связанную группу событий.`)
};

const es_manual_qc_related_group_not_found = /** @type {(inputs: Manual_Qc_Related_Group_Not_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No se pudo encontrar el grupo de eventos relacionado`)
};

const zh_cn2_manual_qc_related_group_not_found = /** @type {(inputs: Manual_Qc_Related_Group_Not_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`找不到相关的事件组`)
};

const ja_manual_qc_related_group_not_found = /** @type {(inputs: Manual_Qc_Related_Group_Not_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`関連するイベントグループが見つかりませんでした`)
};

const hi_manual_qc_related_group_not_found = /** @type {(inputs: Manual_Qc_Related_Group_Not_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`संबंधित इवेंट समूह नहीं मिल सका`)
};

const pt_pt2_manual_qc_related_group_not_found = /** @type {(inputs: Manual_Qc_Related_Group_Not_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Não foi possível encontrar o grupo de eventos relacionado.`)
};

/**
* | output |
* | --- |
* | "Could not find the related event group" |
*
* @param {Manual_Qc_Related_Group_Not_FoundInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const manual_qc_related_group_not_found = /** @type {((inputs?: Manual_Qc_Related_Group_Not_FoundInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Manual_Qc_Related_Group_Not_FoundInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_manual_qc_related_group_not_found(inputs)
	if (locale === "de") return de_manual_qc_related_group_not_found(inputs)
	if (locale === "it") return it_manual_qc_related_group_not_found(inputs)
	if (locale === "ru") return ru_manual_qc_related_group_not_found(inputs)
	if (locale === "es") return es_manual_qc_related_group_not_found(inputs)
	if (locale === "zh-CN") return zh_cn2_manual_qc_related_group_not_found(inputs)
	if (locale === "ja") return ja_manual_qc_related_group_not_found(inputs)
	if (locale === "hi") return hi_manual_qc_related_group_not_found(inputs)
	if (locale === "pt-PT") return pt_pt2_manual_qc_related_group_not_found(inputs)
	return en_manual_qc_related_group_not_found(inputs)
});